import React from "react";
import { Button } from "@/components/common/Button";
import { classNames } from "@/utils/utils";
import { BulbIcon } from "@/components/common/icons/BulbIcon";
import { TranslateIcon } from "@/components/common/icons/TranslateIcon";
import { MicIcon } from "@/components/common/icons/MicIcon";

import styles from "./ChatControlPanel.module.css";

type Props = {
  className?: string;
  disabled?: boolean;
  suggestionDisabled?: boolean;
  onTranslate?: () => void;
  onSuggestion?: () => void;
  onMic?: () => void;
};

export const ChatControlPanel: React.FC<Props> = ({
  className,
  disabled,
  suggestionDisabled,
  onTranslate,
  onSuggestion,
  onMic,
}) => {
  return (
    <div className={classNames(styles.container, className)}>
      {onSuggestion && (
        <Button
          className={styles.button}
          disabled={disabled || suggestionDisabled}
          variant="secondary"
          onClick={onSuggestion}
        >
          <BulbIcon className={styles.bulbIcon} />
          Suggestions
        </Button>
      )}
      {onTranslate && (
        <Button
          className={styles.button}
          disabled={disabled}
          variant="secondary"
          onClick={onTranslate}
        >
          <TranslateIcon className={styles.translateIcon} />
          Traduire
        </Button>
      )}
      {onMic && (
        <Button
          className={styles.button}
          disabled={disabled}
          variant="secondary"
          onClick={onMic}
        >
          <MicIcon className={styles.voiceIcon} />
          Voix
        </Button>
      )}
    </div>
  );
};
